import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";
import ReactModal from "react-modal";
import { isMobileDevice } from "../../helpers/Utils";
import { updateMenuModel, getUserTypes } from "../../actions";
import StyleConstants from "../../shared/constants/styleConstants/styles.json";
import Constants from "../../shared/constants/environmentConfig";
import Modal from "./baseModal";
import Help from "../help";

const cookies = new Cookies();
const IS_MOBILE = isMobileDevice();

const feedbackStyle = {
  height: 28,
  display: "flex",
  alignItems: "center",
  padding: "0 15px",
  borderRadius: 25,
  cursor: "pointer",
  fontSize: 13,
  color: "#FBFBFB",
  whiteSpace: "nowrap",
  background: "#025786",
  fontWeight: "bold",
};

class SideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverMenuIndex: false,
      showHelp: false,
    };
  }

  openHelpModalView() {
    this.setState({ showHelp: true });
  }

  routePage(link) {
    window.location.href = `/${link}`;
  }

  showMenu(menu, key) {
    const { hoverMenuIndex } = this.state;
    const { selectedOption, isOnline, isAccountant, isAdmin, isFinance } = this.props;
    const isSelected = selectedOption === menu.pathname;
    const hoverColor = "#fbfbfb";
    const hoverBackgroundColor = "#003b61";
    const selectedOptionBackgroundColor = "#007fd2";
    let textStyle = {
      color: hoverMenuIndex === key ? hoverColor : "#6E7D90",
      fontWeight: 400,
      fontSize: StyleConstants.textSize.subHeader,
      marginBottom: 0,
      letterSpacing: 0.2,
      paddingLeft: 30,
      paddingTop: 12,
      paddingBottom: 12,
    };
    let boxStyle = {
      backgroundColor: hoverMenuIndex === key ? hoverBackgroundColor : "",
      justifyContent: "center",
      cursor: "pointer",
      borderRadius: 2,
      marginTop: 5,
      marginBottom: 5,
      ":hover": { backgroundColor: "red" },
    };
    if (isSelected) {
      textStyle = {
        color: hoverColor,
        fontSize: StyleConstants.textSize.subHeader,
        marginBottom: 0,
        fontWeight: StyleConstants.textWeight.semiBold,
        letterSpacing: 0.2,
        paddingLeft: 30,
        paddingTop: 12,
        paddingBottom: 12,
      };
      boxStyle = {
        backgroundColor: hoverBackgroundColor,
        justifyContent: "end",
        cursor: "pointer",
        borderRadius: 2,
        marginTop: 5,
        marginBottom: 5,
      };
    }
    if (
      (isOnline && !menu.isOnline) ||
      (isFinance &&
        (menu.key === "tool" ||
          menu.key === "classrooms" ||
          menu.key === "fee_bundle/gst" ||
          menu.key === "dashboard"))
    ) {
      return null;
    }
    return (
      <div
        onMouseEnter={() => this.setState({ hoverMenuIndex: key })}
        role="presentation"
        onMouseLeave={() => this.setState({ hoverMenuIndex: false })}
        onClick={() =>
          isSelected
            ? ""
            : menu.key === "classrooms" ||
              menu.key === "my_institute" ||
              menu.key === "institutes_tags"
            ? window.open(`${Constants().qbankURL}${menu.pathname}`)
            : this.routePage(menu.key)
        }
        key={key}
        style={boxStyle}
      >
        <div style={{ display: "flex", alignItems: "center", height: 50 }}>
          <div
            style={{
              backgroundColor: isSelected ? selectedOptionBackgroundColor : "",
              width: 4,
              height: "60%",
              borderBottomRightRadius: 15,
              borderTopRightRadius: 15,
            }}
          />
          <div style={textStyle}>{menu.name}</div>
          <div
            style={{
              backgroundColor: isSelected ? selectedOptionBackgroundColor : "",
              width: 5,
              height: "60%",
              marginLeft: "auto",
              borderBottomLeftRadius: 15,
              borderTopLeftRadius: 15,
            }}
          />
        </div>
      </div>
    );
  }

  render() {
    const user = cookies.get("user");
    const { menuList, isMenuBar, updateMenuModel, isLocked, isAdmin } =
      this.props;
    const { showHelp } = this.state;
    const isShowList = !isLocked || (isLocked && isAdmin);
    return (
      <div>
        {!IS_MOBILE ? (
          <div
            style={{
              width: "16vw",
              backgroundColor: "#112F56",
              minHeight: "100vh",
              position: "fixed",
              padding: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              marginTop: "70px",
            }}
          >
            <Modal
              header="Contact Us"
              isModalVisible={showHelp}
              handleCloseModal={() => this.setState({ showHelp: false })}
              width="370px"
            >
              <Help />
            </Modal>
            <div style={{ width: "100%" }}>
              {menuList &&
                isShowList &&
                Object.keys(menuList).map((key) =>
                  this.showMenu(menuList[key], key)
                )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: 30,
                background: "#003D60",
                marginBottom: "70px",
              }}
            >
              <div
                role="presentation"
                style={feedbackStyle}
                onClick={() => this.openHelpModalView()}
              >
                Help
              </div>
            </div>
          </div>
        ) : (
          <ReactModal
            ariaHideApp={false}
            isOpen={isMenuBar}
            contentLabel="onRequestClose Example"
            onRequestClose={() => updateMenuModel()}
            style={{
              overlay: {
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "#00000080",
                overflowY: "scroll",
                zIndex: 5,
              },
              content: {
                position: "fixed",
                top: 0,
                left: 0,
                height: "100%",
                width: "75%",
                right: "auto",
                bottom: "auto",
                overflowY: "scroll",
                WebkitOverflowScrolling: "scroll",
                backgroundColor: "#112F56",
                borderColor: "#112F56",
                borderRadius: 0,
                minWidth: "75%",
                padding: 0,
              },
            }}
          >
            <div
              style={{
                background: StyleConstants.color.darkBlue,
                shadow: "#8DFFDF",
              }}
            >
              <div style={{ padding: "25px 30px" }}>
                <div
                  style={{ fontWeight: "bold", fontSize: 20 }}
                  role="presentation"
                  onClick={() => {
                    window.location.href = `/`;
                  }}
                >
                  <span style={{ color: "#e83242" }}>FEE </span>
                  <span style={{ color: StyleConstants.color.white }}>
                    BOARD
                  </span>
                </div>
              </div>
            </div>
            <div>
              {menuList &&
                Object.keys(menuList).map((key) =>
                  this.showMenu(menuList[key], key)
                )}
            </div>
          </ReactModal>
        )}
      </div>
    );
  }
}

SideBar.propTypes = {
  menuList: PropTypes.object,
  selectedOption: PropTypes.number,
  isOnline: PropTypes.bool,
  isMenuBar: PropTypes.bool,
  updateMenuModel: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  isAccountant: PropTypes.bool,
};

SideBar.defaultProps = {
  menuList: {},
  selectedOption: 0,
  isOnline: false,
  isMenuBar: false,
  isAccountant: false,
  isAdmin: false,
};

const mapStateToProps = ({ home, auth }) => ({
  isMenuBar: home.isMenuBar,
  isOnline: home.isOnline,
  isAdmin: auth.isAdmin,
  isAccountant: auth.isAccountant,
  isLocked: home.isLocked,
  isFinance: home.isFinance,
});

export default connect(mapStateToProps, { updateMenuModel, getUserTypes })(
  SideBar
);
